import { useInvoiceLiveCountsSubscription } from "@/queries/invoices/live-counts/live-counts";

import { Count } from "@/components/shared/data-table/total-count";
import { Skeleton } from "@/components/ui/skeleton";
import {
  useDuplicatesInitialQuery,
  useExportInitialQuery,
  useExportedInitialQuery,
  useFastlaneInitialQuery,
  useSortInitialQuery,
  useStandardInitialQuery,
  useUploadsInitialQuery,
} from "@/features/todos/initial-filters";
import type { InvoiceTypeString } from "@/lib/constants/invoice-type";

const CountSkeleton = () => {
  return <Skeleton className="w-[32px] h-[21px] rounded-full" />;
};

type CountProps = {
  type: InvoiceTypeString | null;
};

export const UploadsCount = ({ type }: CountProps) => {
  const { serverSideQuery } = useUploadsInitialQuery({ type });

  const { liveCounts, loading } = useInvoiceLiveCountsSubscription({
    query: serverSideQuery,
  });

  if (loading) return <CountSkeleton />;

  return <Count count={liveCounts} />;
};

export const StandardReviewCount = ({ type }: CountProps) => {
  const { serverSideQuery } = useStandardInitialQuery({ type });

  const { liveCounts, loading } = useInvoiceLiveCountsSubscription({
    query: serverSideQuery,
  });

  if (loading) return <CountSkeleton />;

  return <Count count={liveCounts} />;
};

export const ExportedInvoicesCount = ({ type }: CountProps) => {
  const { serverSideQuery } = useExportedInitialQuery({ type });

  const { liveCounts, loading } = useInvoiceLiveCountsSubscription({
    query: serverSideQuery,
  });

  if (loading) return <CountSkeleton />;

  return <Count count={liveCounts} />;
};

export const ReviewedInvoicesCount = ({ type }: CountProps) => {
  const { serverSideQuery } = useExportInitialQuery({ type });

  const { liveCounts, loading } = useInvoiceLiveCountsSubscription({
    query: serverSideQuery,
  });

  if (loading) return <CountSkeleton />;

  return <Count count={liveCounts} />;
};

export const SortInvoicesCount = ({ type }: CountProps) => {
  const { serverSideQuery } = useSortInitialQuery({ type });

  const { liveCounts, loading } = useInvoiceLiveCountsSubscription({
    query: serverSideQuery,
  });

  if (loading) return <CountSkeleton />;

  return <Count count={liveCounts} />;
};

export const DuplicatesCount = ({ type }: CountProps) => {
  const { serverSideQuery } = useDuplicatesInitialQuery({ type });

  const { liveCounts, loading } = useInvoiceLiveCountsSubscription({
    query: serverSideQuery,
  });

  if (loading) return <CountSkeleton />;

  return <Count count={liveCounts} />;
};

export const FastlaneCount = ({ type }: CountProps) => {
  const { serverSideQuery } = useFastlaneInitialQuery({ type });

  const { liveCounts, loading } = useInvoiceLiveCountsSubscription({
    query: serverSideQuery,
  });

  if (loading) return <CountSkeleton />;

  return <Count count={liveCounts} />;
};
